import { find } from "lodash-es";

/**
 * @typedef {{ ariaLabelledBy?: string | null, ariaLabel?: string | null }} DialogA11yOptions
 * @typedef {{ "aria-labelledby"?: string, "aria-label"?: string }} DialogA11yProps
 */

/** @param {unknown} value */
function isPresent(value) {
  return value != null && value !== "";
}

/**
 * Maps dialog label inputs to ARIA attributes. First defined source wins;
 * later sources are ignored (do not merge).
 *
 * @type {ReadonlyArray<{
 *   source: keyof DialogA11yOptions;
 *   attribute: keyof DialogA11yProps;
 * }>}
 */
const DIALOG_LABEL_SOURCES = [
  { source: "ariaLabelledBy", attribute: "aria-labelledby" },
  { source: "ariaLabel", attribute: "aria-label" },
];

/**
 * Builds `aria-labelledby` / `aria-label` props for `role="dialog"` surfaces.
 * Prefer `ariaLabelledBy` when both are provided.
 *
 * @param {DialogA11yOptions} [options]
 * @returns {DialogA11yProps}
 */
export function dialogA11yProps({
  ariaLabelledBy,
  ariaLabel,
} = {}) {
  const values = { ariaLabelledBy, ariaLabel };

  const match = find(DIALOG_LABEL_SOURCES, ({ source }) =>
    isPresent(values[source]),
  );

  return match ? { [match.attribute]: values[match.source] } : {};
}
